const set1 = [
	{ name: "sein", translation: "ser" },
	{ name: "werden", translation: "ficar, torna-se" },
	{ name: "können", translation: "poder" },
	{ name: "sagen", translation: "dizer" },
	{ name: "machen", translation: "fazer" },
];

const set2 = [
	{ name: "kommen", translation: "vir" },
	{ name: "sollen", translation: "dever" },
	{ name: "gehen", translation: "ir" },
	{ name: "sehen", translation: "ver" },
	{ name: "stehen", translation: "estar de pé" },
];

const set3 = [
	{ name: "finden", translation: "achar" },
	{ name: "bleiben", translation: "ficar" },
	{ name: "heißen", translation: "chamar-se" },
	{ name: "nehmen", translation: "tomar, pegar" },
	{ name: "dürfen", translation: "poder, dever" },
];

const set4 = [
	{ name: "glauben", translation: "acreditar" },
	{ name: "sprechen", translation: "falar" },
	{ name: "leben", translation: "viver" },
	{ name: "fragen", translation: "perguntar" },
	{ name: "stellen", translation: "colocar, pôr" },
];

const set5 = [
	{ name: "spielen", translation: "jogar, tocar" },
	{ name: "arbeiten", translation: "trabalhar" },
	{ name: "brauchen", translation: "precisar" },
	{ name: "lernen", translation: "aprender" },
	{ name: "verstehen", translation: "entender" },
];

const set6 = [
	{ name: "schreiben", translation: "escrever" },
	{ name: "fallen", translation: "cair" },
	{ name: "gehören", translation: "pertencer" },
	{ name: "suchen", translation: "procurar" },
	{ name: "versuchen", translation: "tentar" },
];

const setArray = [set1,set2,set3,set4,set5,set6];
export default setArray
